import React from 'react';
import { Link } from 'react-router-dom';
import { MessageSquare, ArrowLeft } from 'lucide-react';
import Footer from '../components/Footer';

const TermsPage = () => {
  return (
    <div className="min-h-screen bg-white dark:bg-slate-950 flex flex-col">
      <div className="flex-1">
        <div className="max-w-4xl mx-auto px-4 py-12">
          <Link to="/" className="inline-flex items-center gap-2 text-slate-600 hover:text-slate-900 mb-8">
            <ArrowLeft className="w-4 h-4" />
            Back to home
          </Link>
        
          <div className="flex items-center gap-2 mb-8">
            <div className="w-10 h-10 bg-emerald-700 rounded-xl flex items-center justify-center">
              <MessageSquare className="w-6 h-6 text-white" />
            </div>
            <span className="font-bold text-2xl text-slate-900 dark:text-white">Flowteras</span>
          </div>
        
          <h1 className="text-4xl font-bold text-slate-900 dark:text-white mb-8" data-testid="terms-title">
            Terms of Service
          </h1>
        
          <div className="prose prose-lg dark:prose-invert max-w-none">
            <p className="text-slate-600 dark:text-slate-400">Last updated: April 2026</p>

            <div className="bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-lg p-6 my-8" data-testid="terms-entity-attribution">
              <p className="text-slate-800 dark:text-slate-200 font-medium">
                Flowteras is developed, owned, and operated by GREENMOUNT SOLUTIONS SDN. BHD.
              </p>
            </div>
          
            <h2 className="text-2xl font-semibold text-slate-900 dark:text-white mt-8 mb-4">1. Acceptance of Terms</h2>
            <p className="text-slate-600 dark:text-slate-400 mb-6">
              By accessing or using Flowteras, you agree to be bound by these Terms of Service and all applicable laws and regulations. If you do not agree with any of these terms, you are prohibited from using or accessing this service.
            </p>
          
            <h2 className="text-2xl font-semibold text-slate-900 dark:text-white mt-8 mb-4">2. Use License</h2>
            <p className="text-slate-600 dark:text-slate-400 mb-4">
              Subject to your compliance with these Terms, we grant you a limited, non-exclusive, non-transferable license to:
            </p>
            <ul className="list-disc list-inside text-slate-600 dark:text-slate-400 space-y-2 mb-6">
              <li>Access and use Flowteras for your internal business purposes</li>
              <li>Connect your WhatsApp Business account to our platform</li>
              <li>Use our AI and automation features within your subscription limits</li>
            </ul>
          
            <h2 className="text-2xl font-semibold text-slate-900 dark:text-white mt-8 mb-4">3. Account Responsibilities</h2>
            <p className="text-slate-600 dark:text-slate-400 mb-6">
              You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. You agree to notify us immediately of any unauthorized use of your account.
            </p>
          
            <h2 className="text-2xl font-semibold text-slate-900 dark:text-white mt-8 mb-4">4. Prohibited Uses</h2>
            <p className="text-slate-600 dark:text-slate-400 mb-4">
              You may not use Flowteras to:
            </p>
            <ul className="list-disc list-inside text-slate-600 dark:text-slate-400 space-y-2 mb-6">
              <li>Send spam or unsolicited messages</li>
              <li>Violate any laws or regulations</li>
              <li>Infringe upon intellectual property rights</li>
              <li>Transmit malicious code or interfere with the service</li>
              <li>Collect user data without consent</li>
            </ul>
          
            <h2 className="text-2xl font-semibold text-slate-900 dark:text-white mt-8 mb-4">5. Billing and Payment</h2>
            <p className="text-slate-600 dark:text-slate-400 mb-6">
              Subscription fees are billed in advance on a monthly basis. You agree to pay all applicable fees associated with your subscription plan. Failure to pay may result in suspension or termination of your account.
            </p>
          
            <h2 className="text-2xl font-semibold text-slate-900 dark:text-white mt-8 mb-4">6. Termination</h2>
            <p className="text-slate-600 dark:text-slate-400 mb-6">
              We may terminate or suspend your account immediately, without prior notice, for any breach of these Terms. Upon termination, your right to use the service will cease immediately.
            </p>
          
            <h2 className="text-2xl font-semibold text-slate-900 dark:text-white mt-8 mb-4">7. Limitation of Liability</h2>
            <p className="text-slate-600 dark:text-slate-400 mb-6">
              In no event shall Flowteras be liable for any indirect, incidental, special, consequential, or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses.
            </p>
          
            <h2 className="text-2xl font-semibold text-slate-900 dark:text-white mt-8 mb-4">8. Contact</h2>
            <p className="text-slate-600 dark:text-slate-400 mb-6">
              For questions about these Terms, please contact us at legal@flowteras.com.
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default TermsPage;
